import { PageHeader } from "../components/Section";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="ABOUT THE COUNCIL"
        title="A gathering rooted in the presence of Yahweh"
        subtitle="Assembly of Yahweh Shammah Council is a covenant community devoted to Scripture, sabbath, and sanctified living."
        bg="https://images.unsplash.com/photo-1519491050282-cf00c82424b4?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80"
      />
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-8 text-zinc-300 leading-relaxed">
          <p>
            The Assembly of Yahweh Shammah Council was gathered by the Spirit of the Most High to be a witness of His name and His presence in this generation. Our name, drawn from the last verse of the book of Ezekiel — <em className="text-gold">Yahweh Shammah</em>, "Yahweh is There" — is both our confession and our promise.
          </p>
          <p>
            We are a Sabbath-keeping, feast-observing, Torah-honoring assembly. We hold that the Scriptures — Genesis through Revelation — are the fully inspired Word of the Living God, and that all doctrine and practice must be measured by them.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8">
            {[
              { t: "Our Mission", d: "To exalt the name of Yahweh, disciple His people in His Word, and shine as a lampstand in our generation." },
              { t: "Our Vision", d: "A restored and gathered assembly, awaiting the return of the Messiah and the fullness of Yahweh Shammah." },
              { t: "Our Council", d: "A body of ordained elders, teachers, and deacons serving in unity under the Spirit of the Most High." },
            ].map((b) => (
              <div key={b.t} className="border hairline rounded-xl p-6 surface">
                <div className="font-accent text-xs text-gold mb-3">{b.t.toUpperCase()}</div>
                <p className="text-sm text-zinc-300 leading-relaxed">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
